export const QuestionTypes = [
  { value: "mcq", label: "Multiple Choice" },
  { value: "true_false", label: "True False" },
  { value: "blank", label: "Fill in the Blanks" },
  {
    value: "multiple_blanks",
    label: "Fill in Multiple Blanks",
  },
  { value: "multiple_answers", label: "Multiple answers" },
  { value: "multiple_dropdown", label: "Multiple Dropdowns" },
  { value: "matching", label: "Matching" },
  { value: "numerical", label: "Numerical Answer" },
  { value: "essay", label: "Essay Question" },
  {
    value: "file_upload",
    label: "File Upload Question",
  },
  { value: "speaking", label: "Speaking" },
];

// IELTS-specific question types
export const IELTSQuestionTypes = {
  listening: [
    { value: "ielts_listening_mcq", label: "Multiple Choice" },
    { value: "ielts_listening_fill", label: "Fill in the Blanks" },
    { value: "ielts_listening_matching", label: "Matching" },
    { value: "ielts_listening_short_answer", label: "Short Answer" },
    { value: "ielts_listening_completion", label: "Completion" },
  ],
  reading: [
    { value: "ielts_reading_mcq", label: "Multiple Choice" },
    { value: "ielts_reading_tfng", label: "True/False/Not Given" },
    { value: "ielts_reading_ynng", label: "Yes/No/Not Given" },
    { value: "ielts_reading_matching", label: "Matching" },
    { value: "ielts_reading_completion", label: "Completion" },
    { value: "ielts_reading_short_answer", label: "Short Answer" },
    { value: "ielts_reading_summary", label: "Summary Completion" },
  ],
  writing: [
    {
      value: "ielts_writing_task1_academic",
      label: "Task 1 - Academic (Charts/Graphs)",
    },
    {
      value: "ielts_writing_task1_general",
      label: "Task 1 - General (Letter)",
    },
    { value: "ielts_writing_task2", label: "Task 2 - Essay" },
  ],
  speaking: [
    { value: "ielts_speaking_part1", label: "Part 1 - Personal Questions" },
    { value: "ielts_speaking_part2", label: "Part 2 - Cue Card" },
    { value: "ielts_speaking_part3", label: "Part 3 - Discussion" },
  ],
};

export const QuestionDifficultyLevels = [
  { value: "Easy", label: "Easy" },
  { value: "Medium", label: "Medium" },
  { value: "Hard", label: "Hard" },
];

export const OptionsIndex = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const NumericalOptionsTypes = [
  "Exact Answer:",
  "Answer in the Range:",
  "Answer with Precision:",
];

// IELTS Section Configurations
export const IELTSSections = [
  {
    id: "listening",
    name: "Listening",
    icon: "📻",
    duration: 30,
    description: "Audio recordings with questions",
    questionCount: 40,
  },
  {
    id: "reading",
    name: "Reading",
    icon: "📖",
    duration: 60,
    description: "Passages with various question types",
    questionCount: 40,
  },
  {
    id: "writing",
    name: "Writing",
    icon: "✍️",
    duration: 60,
    description: "Two writing tasks",
    questionCount: 2,
  },
  {
    id: "speaking",
    name: "Speaking",
    icon: "🎤",
    duration: 14,
    description: "Three-part speaking test",
    questionCount: null, // Variable
  },
];

// IELTS Exam Types
export const IELTSExamTypes = [
  { value: "academic", label: "Academic" },
  { value: "general", label: "General Training" },
];

// IELTS Band Scores
export const IELTSBandScores = [
  { value: 9, label: "9 - Expert User" },
  { value: 8.5, label: "8.5 - Very Good User+" },
  { value: 8, label: "8 - Very Good User" },
  { value: 7.5, label: "7.5 - Good User+" },
  { value: 7, label: "7 - Good User" },
  { value: 6.5, label: "6.5 - Competent User+" },
  { value: 6, label: "6 - Competent User" },
  { value: 5.5, label: "5.5 - Modest User+" },
  { value: 5, label: "5 - Modest User" },
  { value: 4.5, label: "4.5 - Limited User+" },
  { value: 4, label: "4 - Limited User" },
  { value: 3.5, label: "3.5 - Extremely Limited User+" },
  { value: 3, label: "3 - Extremely Limited User" },
  { value: 2.5, label: "2.5 - Intermittent User+" },
  { value: 2, label: "2 - Intermittent User" },
  { value: 1, label: "1 - Non User" },
];

// IELTS Writing Task Types
export const IELTSWritingTasks = {
  task1_academic: [
    "Line Graph",
    "Bar Chart",
    "Pie Chart",
    "Table",
    "Process Diagram",
    "Map",
    "Multiple Charts",
  ],
  task1_general: ["Formal Letter", "Informal Letter", "Semi-formal Letter"],
  task2: [
    "Opinion Essay",
    "Discussion Essay",
    "Problem/Solution Essay",
    "Advantage/Disadvantage Essay",
  ],
};

// Letter Scenarios for General Training Task 1
export const letterScenarios = {
  formal: [
    {
      id: "complaint_service",
      title: "Service Complaint",
      scenario:
        "You recently received poor service at a restaurant/hotel/shop. Write a formal complaint letter.",
      recipient: "Manager",
      requirements: [
        "Describe what happened",
        "Explain how you felt about the service",
        "Say what you want the manager to do",
      ],
    },
    {
      id: "job_application",
      title: "Job Application",
      scenario:
        "You saw a job advertisement and want to apply for the position.",
      recipient: "Human Resources Manager",
      requirements: [
        "Explain which position you are applying for",
        "Describe your qualifications and experience",
        "Say when you are available for an interview",
      ],
    },
    {
      id: "housing_issue",
      title: "Housing Problem",
      scenario:
        "You are renting an apartment and there are problems that need the landlord's attention.",
      recipient: "Landlord",
      requirements: [
        "Describe the problems",
        "Explain how the problems affect you",
        "Suggest what you would like the landlord to do",
      ],
    },
  ],
  semiformal: [
    {
      id: "neighbor_issue",
      title: "Neighbor Concern",
      scenario:
        "Your neighbors are causing problems (noise, parking, pets) and you need to address this.",
      recipient: "Neighbor",
      requirements: [
        "Explain the problem",
        "Describe how it affects you",
        "Suggest a solution",
      ],
    },
    {
      id: "course_inquiry",
      title: "Course Information Request",
      scenario: "You want to enroll in a course and need more information.",
      recipient: "Course Coordinator",
      requirements: [
        "Explain your interest in the course",
        "Ask for specific information you need",
        "Request a meeting or phone call",
      ],
    },
    {
      id: "work_colleague",
      title: "Work Colleague Request",
      scenario:
        "You need to ask a colleague for help or make a work-related request.",
      recipient: "Work Colleague",
      requirements: [
        "Explain the situation",
        "Make your request clearly",
        "Offer something in return if appropriate",
      ],
    },
  ],
  informal: [
    {
      id: "friend_visit",
      title: "Friend Visit Invitation",
      scenario:
        "You want to invite a friend to visit you in your city/country.",
      recipient: "Friend",
      requirements: [
        "Invite your friend to visit",
        "Suggest dates and activities",
        "Give information about accommodation",
      ],
    },
    {
      id: "apology_friend",
      title: "Apology to Friend",
      scenario:
        "You need to apologize to a friend for missing an important event or making a mistake.",
      recipient: "Friend",
      requirements: [
        "Apologize for what happened",
        "Explain why it happened",
        "Suggest how to make up for it",
      ],
    },
    {
      id: "family_news",
      title: "Family News Update",
      scenario:
        "You want to update a family member about recent events in your life.",
      recipient: "Family Member",
      requirements: [
        "Share your recent news",
        "Ask about their life",
        "Make plans to meet or call",
      ],
    },
  ],
};

// Essay Topics for Task 2
export const essayTopics = {
  academic: {
    opinion: [
      "The role of technology in modern education and its impact on traditional learning methods",
      "Whether governments should prioritize economic development over environmental protection",
      "The effectiveness of international cooperation in addressing global challenges",
      "The impact of social media on academic research and scholarly communication",
    ],
    discussion: [
      "The benefits and drawbacks of globalization on local cultures and economies",
      "Different approaches to urban planning: high-density vs. low-density development",
      "Various methods of addressing climate change: technological vs. behavioral solutions",
      "Competing theories about the future of work in an automated society",
    ],
    problemSolution: [
      "The growing problem of academic dishonesty in higher education institutions",
      "Rising healthcare costs and accessibility issues in developed countries",
      "The challenge of maintaining biodiversity in the face of urban expansion",
      "Declining literacy rates among young people in the digital age",
    ],
    advantageDisadvantage: [
      "The trend of pursuing higher education abroad rather than in one's home country",
      "The increasing use of artificial intelligence in academic research",
      "The shift towards renewable energy sources in industrial societies",
      "The growing popularity of online learning platforms in higher education",
    ],
  },
  general: {
    opinion: [
      "Whether children should be given mobile phones at an early age",
      "The importance of learning a foreign language in today's globalized world",
      "Whether people should prioritize career success over family life",
      "The role of social media in maintaining friendships and relationships",
    ],
    discussion: [
      "The benefits and drawbacks of working from home",
      "Different opinions about the best way to stay healthy and fit",
      "Various approaches to raising children: strict vs. permissive parenting",
      "Different views on the importance of saving money vs. enjoying life",
    ],
    problemSolution: [
      "The problem of traffic congestion in major cities",
      "Rising obesity rates among children and adults",
      "The challenge of maintaining work-life balance in modern society",
      "The issue of elderly people feeling isolated in communities",
    ],
    advantageDisadvantage: [
      "Living in a large city versus a small town",
      "The trend of people changing careers multiple times during their working life",
      "The increasing popularity of online shopping compared to traditional retail",
      "The growing number of people choosing to live alone rather than with family",
    ],
  },
};

// IELTS Reading Passage Types
export const IELTSReadingPassageTypes = {
  academic: [
    "Academic Articles",
    "Research Papers",
    "Scientific Journals",
    "Academic Books",
  ],
  general: [
    "Advertisements",
    "Notices",
    "Instruction Manuals",
    "Newspapers",
    "Magazines",
    "Timetables",
    "Books",
  ],
};

export const truncateText = (text, maxLength) => {
  if (text?.length > maxLength) {
    return text?.substring(0, maxLength) + "...";
  }
  return text;
};
